import React, { useCallback, useEffect, useState } from 'react';
import {AnsweredIcon} from '../../../Icons/IconPackage/Answered'
import './index.scss';

export const STATUS_POLL = {
    new: "new",
    answered: "answered",
};

const PollIndicator = ({status, $locale}) => {
    const className = "poll-indicator";
    
    switch (status) {
        case STATUS_POLL.new:
            return (
                <div className={`${className} --new`}>{$locale.get('polls.new')}</div>
            );
        case STATUS_POLL.answered:
            return (
                <div className={`${className} --answered`}>
                    <AnsweredIcon />
                    {$locale.get('polls.answered')}
                </div>
            );
        default:
            return null;
    }
}

const PollItem = ({poll, $locale, onPollHandler, status}) => {
    const className = "poll-item" + (status ? ` --${status}` : '');

    const onHandler = () => {
        onPollHandler(poll);
    }

    return (
        <div className={className} onClick={onHandler}>
            <div className="poll-item--title">
                {$locale.getProperty(poll, 'text')}
            </div>
            <PollIndicator status={status} $locale={$locale} />
        </div>
    )
};

export default PollItem;
